function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: [{ title: 'Transaction Date', filter: 'dateFull' }, { title: 'Amount', filter: 'toCurrency' }, 'Entries', { title: 'Entered', filter: 'dateFull' }, { title: 'Updated', filter: 'dateFull' }],
            fields: ['post_date', 'credit_total', 'count', 'created_at', 'updated_at'],
            items: [],
            loading: true
        };
    },
    mounted: function mounted() {
        var _this = this;

        var $el = this;

        $el.load();

        Event.$on('add-entry', function () {
            Event.$emit('add-new-journal-entry');
        });

        Event.$on('update-entry', function (item) {
            //if(moment(item.transaction_date).isSame(moment(item.transaciton_date).clone().startOf('day'), 'd')) {
            Event.$emit('update-journal-entry', item);
            //} else {
            //    alert('You can only edit items with a transaction date of today...')
            //    return false
            //}
        });

        Event.$on('import-entry', function (item, idx) {
            Event.$emit('import-journal-entry');
        });

        Event.$on('remove-entry', function (item, idx) {
            if (_this.hasReconcile(item)) {
                alert('This batch has an entry that is associated with a bank reconcile and cannot be deleted.');
                return false;
            } else {
                Event.$emit('confirm-delete', item, '/prototype/accounting/general-ledger/journal-entry/remove', 'delete-entry', 'Are you sure you want to delete this journal entry?', 'Delete');
            }
        });

        Event.$on('delete-entry', function (item) {
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        });

        Event.$on('view-entry', function (item, idx) {
            Event.$emit('show-flyout', 'Journal Entry Details', '/prototype/accounting/general-ledger/journal-entry/view', 'journal-entry-details', item);
        });

        Event.$on('refresh-journal-entries', function () {
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var search = arguments[1];
            var sort = arguments[2];
            var order = arguments[3];
            var isDate = arguments[4];

            $el.load(offset, search, sort, order, isDate);
        });
    },


    methods: {
        load: function load(offset) {
            var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
            var sort = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post_date';
            var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DESC';
            var isDate = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;


            Event.$emit('data-table-loading');

            var self = this;
            var data = {
                offset: offset,
                search: search,
                sort: sort,
                order: order,
                isDate: isDate
            };

            axios.post('/prototype/accounting/general-ledger/journal-entry/fetch', data).then(function (response) {

                offset !== 0 ? self.items = [].concat(_toConsumableArray(self.items), _toConsumableArray(response.data.entries)) : self.items = response.data.entries;

                self.items.map(function (item) {
                    item['count'] = Object.keys(item.debits).length + Object.keys(item.credits).length;
                });

                Event.$emit('data-table-loaded');
            });
        },
        hasReconcile: function hasReconcile(item) {
            return item.entries.some(function (entry) {
                return entry.reconcile_entry !== null;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/journal-entry/JournalEntryList.vue
// module id = My/w
// module chunks = 0 1